import AuthService from '../../../../services/auth-service';
import ErrorFormatService from '../../../../services/error-format-service';
import {
  CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_ERROR, RESET_PASSWORD_RECOVERED, RESET_FORM_ERRORS,
} from '../../../../constants/system/actions';

const passwordRecoveryReducer: Reducer = (
  state: ReducerState = {
    isPasswordRecovered: false,
    actionHash: null,
    actionType: null,
    homepageRoute: null,
    formErrors: {},
    isFormSaving: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case CHANGE_PASSWORD:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case CHANGE_PASSWORD_SUCCESS:
      if (action.data.authToken) {
        AuthService.setAuthToken(action.data.authToken);
      }

      if (action.data.deviceId) {
        AuthService.setDeviceId(action.data.deviceId);
      }

      if (action.data.actionHash && action.data.actionType) {
        return {
          ...state,
          actionHash: action.data.actionHash,
          actionType: action.data.actionType,
          formErrors: {},
          isFormSaving: false,
        };
      }

      return {
        ...state,
        isPasswordRecovered: true,
        homepageRoute: action.data.homepageRoute || null,
        formErrors: {},
        isFormSaving: false,
      };
    case CHANGE_PASSWORD_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case RESET_PASSWORD_RECOVERED:
      return {
        ...state,
        isPasswordRecovered: false,
        actionHash: null,
        actionType: null,
        formErrors: {},
        isFormSaving: false,
      };
    default:
      return state;
  }
};

export default passwordRecoveryReducer;
